import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apiMainUser } from "../constant";
import { chatEntryExit } from "../api";

export const chatEntryExitThunk = createAsyncThunk(
  "chatEntryExit",
  async ({ oldRoomID, newRoomID }) => {
    try {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      if (oldRoomID) {
        await axios.post(
          apiMainUser + "chat_entry_exit",
          {
            chat_room_id: oldRoomID,
            event: "exit",
          },
          { headers }
        );
      }

      if (newRoomID) {
        axios.post(
          apiMainUser + "chat_entry_exit",
          {
            chat_room_id: newRoomID,
            event: "entry",
          },
          { headers }
        );
      }

      console.log("Entered chat room:", newRoomID);
      console.log("Existed chat room:", oldRoomID);
    } catch (error) {
      console.error("Error entering chat room:", error);
    }
  }
);

export const fetchChatByRoomIdThunk = createAsyncThunk(
  "Messages/get",
  async ({ roomId }, { dispatch }) => {
    console.log("inside messages fetch dispatch call");
    try {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await axios.get(
        apiMainUser + `read_chat_user/${roomId}`,
        { headers }
      );

      if (response.status === 200) {
        console.log("API Response:", response.data);
        // setRightSideContent(response.data.data.chat_room_details[0]);
        // dispatch(
        //   SET_RIGHT_SIDE_CONTENT(response.data.data.chat_room_details[0])
        // );

        // dispatch(
        //   SET_SELECTED_ROOM_ID_MESSAGES(response.data.data.message_array)
        // );

        return response.data;
        // setMessages(response.data.data.message_array);
      } else {
        console.error("Failed to fetch chat:", response.status);
      }
    } catch (error) {
      console.error("Error fetching chat:", error);
    }
  }
);

export const getChatRooms = createAsyncThunk(
  "chatRooms/get",
  async ({ type }, { dispatch }) => {
    try {
      dispatch(SET_CHATROOMS_LOADIND(true));

      const url =
        apiMainUser + (type === 0 ? "get_chat_rooms" : "get_chat_rooms_host");

      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (response.status === 200) {
        const roomData = response.data.data;
        dispatch(SET_ASSET_URL(response.data.assets_url));

        // setChatRoomsHost(roomData.reverse());

        console.log("roomData", roomData);
        dispatch(SET_CHATROOMS(roomData.reverse()));

        const initialRoomId = roomData[0]?.room_id;

        dispatch(SET_SELECTED_ROOM_ID(initialRoomId));

        // await dispatch(
        //   chatEntryExitThunk({ oldRoomID: null, newRoomID: initialRoomId })
        // );

        // chatEntryExit({ oldRoomID: null, newRoomID: initialRoomId });

        // dispatch(
        //   chatEntryExitThunk({ oldRoomID: null, newRoomID: initialRoomId })
        // )
        //   .unwrap()
        //   .then((result) => {
        //     console.log("Thunk completed with result:", result);
        //     // Handle any additional logic after thunk completes
        //   })
        //   .catch((error) => {
        //     console.error("Thunk failed with error:", error);
        //     // Handle error as needed
        //   });

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("room_id", initialRoomId);

        const newUrl = queryParams.toString()
          ? `${window.location.pathname}?${queryParams.toString()}`
          : window.location.pathname;

        window.history.replaceState({}, "", newUrl);
      } else {
        console.error("Failed to fetch:", response.status);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  }
);

const initialState = {
  selectedRoomId: null,
  selectedRoomIdMessages: [],
  pusherInstance: null,
  channelInstance: null,

  rightSideContent: null,
  chatRoomUnreadCount: null,
  chatRooms: [],
  userType: 0,
  chatRoomsLoading: null,
  assetsurl: null,

  chatRoomsHostSide: [],
  chatRoomsHostSideLoading: null,
  chatRoomUnreadCountHostSide: null,

  messagesLoading: null,
  messagesError: null,
};

const MessageSlice = createSlice({
  name: "Message",
  initialState,
  reducers: {
    SET_SELECTED_ROOM_ID: (state, action) => {
      const { room_id, type } = action.payload;

      state.selectedRoomIdMessages = [];
      state.selectedRoomId = room_id;

      if (type == 0) {
        state.chatRoomUnreadCount = {
          ...state.chatRoomUnreadCount,
          [room_id]: 0,
        };
        state.chatRoomsLoading = false;
      }

      if (type == 1) {
        state.chatRoomUnreadCountHostSide = {
          ...state.chatRoomUnreadCountHostSide,
          [room_id]: 0,
        };
        state.chatRoomsHostSideLoading = false;
      }
    },

    SET_SELECTED_ROOM_ID_MESSAGES: (state, action) => {
      state.selectedRoomIdMessages = [];
      state.selectedRoomIdMessages = action.payload;
    },

    ADD_MESSAGE: (state, action) => {
      const { roomId, message } = action.payload;
      // Only add the message if it belongs to the current room

      const present = state.selectedRoomIdMessages.filter(
        (messageInMap) => messageInMap.createdon == message.createdon
      )[0];

      if (state.selectedRoomId === roomId && !present) {
        console.log("not present");
        state.selectedRoomIdMessages = [
          message,
          ...state.selectedRoomIdMessages,
        ];
      }
    },

    SET_PUSHER: (state, action) => {
      state.pusherInstance = action.payload;
    },

    SET_CHANNEL: (state, action) => {
      state.channelInstance = action.payload;
    },

    SET_RIGHT_SIDE_CONTENT: (state, action) => {
      state.rightSideContent = action.payload;
    },

    INITIALIZE_CHATROOM_UNREAD_COUNT: (state, action) => {
      const { type, chatRoomUnreadCount } = action.payload;
      if (type == 0) state.chatRoomUnreadCount = chatRoomUnreadCount;
      if (type == 1) state.chatRoomUnreadCountHostSide = chatRoomUnreadCount;
    },

    INCREASE_UNREAD_COUNT_BY_ROOMID: (state, action) => {
      const { type, roomID } = action.payload;

      if (state.selectedRoomId != roomID) {
        // const roomID = action.payload;

        if (type == 0) {
          const chatRoomWithRoomId = state.chatRooms.filter(
            (room) => roomID === room.room_id
          )[0];

          const chatRoomWithOutRoomId = state.chatRooms.filter(
            (room) => roomID != room.room_id
          );

          const updatedChatRooms = [
            chatRoomWithRoomId,
            ...chatRoomWithOutRoomId,
          ];

          state.chatRooms = [chatRoomWithRoomId, ...chatRoomWithOutRoomId];

          state.chatRoomUnreadCount = {
            ...state.chatRoomUnreadCount,
            [roomID]: state.chatRoomUnreadCount[roomID] + 1,
          };
        }

        if (type == 1) {
          const chatRoomWithRoomId = state.chatRoomsHostSide.filter(
            (room) => roomID === room.room_id
          )[0];

          const chatRoomWithOutRoomId = state.chatRoomsHostSide.filter(
            (room) => roomID != room.room_id
          );

          state.chatRoomsHostSide = [
            chatRoomWithRoomId,
            ...chatRoomWithOutRoomId,
          ];

          state.chatRoomUnreadCountHostSide = {
            ...state.chatRoomUnreadCountHostSide,
            [roomID]: state.chatRoomUnreadCountHostSide[roomID] + 1,
          };
        }
      }
      // state.chatRoomUnreadCount[roomID] = state.chatRoomUnreadCount[roomID] + 1;
    },

    SET_CHATROOMS: (state, action) => {
      const { roomData, type } = action.payload;

      if (type == 0) {
        state.chatRooms = roomData;
        state.chatRoomsLoading = false;
      }

      if (type == 1) {
        state.chatRoomsHostSide = roomData;
        state.chatRoomsHostSideLoading = false;
      }
    },

    SET_USER_TYPE: (state, action) => {
      state.userType = action.payload;
    },

    RESET_STATE: (state, action) => {
      state.channelInstance = null;
      state.chatRoomUnreadCount = null;
      state.chatRooms = null;
      state.selectedRoomId = null;
      state.selectedRoomIdMessages = null;
      state.pusherInstance = null;
      state.rightSideContent = null;
    },

    SET_CHATROOMS_LOADIND: (state, action) => {
      const type = action.payload;
      if (type == 0) state.chatRoomsLoading = true;
      if (type == 1) state.chatRoomsHostSideLoading = true;
    },

    SET_ASSET_URL: (state, action) => {
      state.assetsurl = action.payload;
    },

    SET_MESSAGES_LOADING: (state, action) => {
      state.messagesLoading = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getChatRooms.pending, (state, action) => {
      state.chatRooms = null;
      state.chatRoomsLoading = true;
    });

    builder.addCase(getChatRooms.fulfilled, (state, action) => {
      state.chatRooms = action.payload;
      state.chatRoomsLoading = false;
    });

    builder.addCase(fetchChatByRoomIdThunk.pending, (state, action) => {
      state.messagesLoading = true;
      state.messagesError = false;
      state.selectedRoomIdMessages = [];
      state.rightSideContent = null;
    });

    builder.addCase(fetchChatByRoomIdThunk.fulfilled, (state, action) => {
      state.messagesLoading = false;
      state.messagesError = false;
      state.selectedRoomIdMessages = action.payload.data.message_array;
      state.rightSideContent = action.payload.data.chat_room_details[0];
    });

    builder.addCase(fetchChatByRoomIdThunk.rejected, (state, action) => {
      state.messagesError = true;
      state.messagesLoading = false;
      state.selectedRoomIdMessages = [];
      state.rightSideContent = null;
    });
  },
});

export const {
  SET_SELECTED_ROOM_ID,
  SET_SELECTED_ROOM_ID_MESSAGES,
  SET_RIGHT_SIDE_CONTENT,
  ADD_MESSAGE,
  SET_PUSHER,
  SET_CHANNEL,
  INITIALIZE_CHATROOM_UNREAD_COUNT,
  INCREASE_UNREAD_COUNT_BY_ROOMID,
  SET_CHATROOMS,
  SET_USER_TYPE,
  RESET_STATE,
  SET_CHATROOMS_LOADIND,
  SET_ASSET_URL,
  SET_MESSAGES_LOADING,
} = MessageSlice.actions;

export const MessageReducer = MessageSlice.reducer;
